import BackboneElement from '../BackboneElement';
import merge from 'lodash/merge';
import CodeableConcept from '@/fhirworks/types/CodeableConcept';
import TimingRepeat from '@/fhirworks/TimingRepeat';

export default class Timing extends BackboneElement {
    static __className = 'Timing';

    __objectStructure = {
        event: [String],
        code: CodeableConcept,
        repeat: TimingRepeat, // When the event is to occur

        // First-class extensions
        durationQualifier: CodeableConcept, // Qualitative duration ("during-treatment", "other" + free-text in .text) when standard duration/durationUnit doesn't fit
    };

    constructor(constructJson, className = 'Timing') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
